import type {StoreEnhancer} from 'redux';
import {
	applyMiddleware,
	legacy_createStore as createStore,
	compose,
} from 'redux';
import {thunk} from 'redux-thunk';

// Reducers
import createReducer from '@deezer/next/shared/store/reducers';
import type {RootState} from '@deezer/next/shared/store/types';

interface WindowWithRedux extends Window {
	__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (
		storeEnhancer: StoreEnhancer,
	) => StoreEnhancer;
}

const defaultState = {};

function getInitialState(appState: RootState = defaultState): RootState {
	return {
		...appState,
	};
}

const configureStore = (appState?: RootState) => {
	const composeEnhancers =
		(typeof window !== 'undefined' &&
			(window as WindowWithRedux).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
		compose;
	return createStore(
		createReducer(),
		getInitialState(appState),
		composeEnhancers(applyMiddleware(thunk)),
	);
};

export default configureStore;
